import {
  all,
  call,
  put,
  select,
  takeEvery,
} from 'redux-saga/effects';

import { listingApi } from '../../api';
import {
  errorHandler, successHandler,
} from '../../libs/ga';
import {
  cloneDeep,
  forEach,
} from '../../libs/lodash';

import {
  TYPE,
} from './constants';

function* storeType(data = {}, merge = true) {
  yield put({
    type: TYPE.update,
    data,
    merge,
  });
}

function* fetchType({
  data,
}) {
  yield* storeType(data);
}

function* updateType({
  data, onSuccess,
}) {
  try {
    const {
      _id,
      ...rest
    } = data;
    if (_id) {
      yield call(() => new Promise((resolve, reject) => {
        listingApi.update({
          collection: 'type',
          payload: {
            _id,
            data: rest,
          },
        }).then(() => resolve(true))
          .catch((error) => reject(error));
      }));
      yield* storeType({
        [data._id]: data,
      });
    } else {
      const {
        newData,
      } = yield call(() => new Promise((resolve, reject) => {
        listingApi.create({
          collection: 'type',
          payload: {
            data,
          },
        }).then((res) => resolve(res.data))
          .catch((err) => reject(err));
      }));
      yield* storeType({
        [newData._id]: newData,
      });
    }
    successHandler('Thành công', 'Cập nhật thành công', onSuccess);
  } catch (error) {
    yield* storeType();
    errorHandler('Thất bại', error);
  }
}

function* removeType({
  _id,
}) {
  const {
    type,
  } = yield select();
  try {
    yield call(() => new Promise((resolve, reject) => {
      listingApi.remove({
        collection: 'type',
        payload: {
          _id,
        },
      }).then(() => resolve(true))
        .catch((error) => reject(error));
    }));

    const newData = cloneDeep(type.data);
    delete newData[_id];
    yield* storeType(newData, false);

    successHandler('Thành công', 'Xóa thành công');
  } catch (error) {
    yield* storeType();
    errorHandler('Thất bại', error);
  }
}

function* importType({
  data = [],
}) {
  const {
    type,
  } = yield select();
  yield call(() => new Promise((resolve, reject) => {
    listingApi.importData({
      collection: 'type',
      payload: {
        data,
      },
    }).then(() => resolve(true))
      .catch((err) => reject(err));
  }));
  const newData = cloneDeep(type.data);
  forEach(
    (obj) => {
      newData[obj._id] = obj;
    },
    data,
  );
  yield* storeType(newData);
  successHandler('Thành công', 'Cập nhật thành công');
}

export default function* typeSaga() {
  yield all([
    yield takeEvery(TYPE.handlers.fetch, fetchType),
    yield takeEvery(TYPE.handlers.update, updateType),
    yield takeEvery(TYPE.handlers.import, importType),
    yield takeEvery(TYPE.handlers.remove, removeType),
  ]);
}
